import pako from 'pako';

/**
 * Decompress transcript segments from Firestore Bytes
 */
export function decompressTranscript(data) {
  try {
    // Handle Firestore Bytes object
    if (data._byteString?.binaryString) {
      // Convert binary string to Uint8Array
      const binaryStr = data._byteString.binaryString;
      const bytes = new Uint8Array(binaryStr.length);
      for (let i = 0; i < binaryStr.length; i++) {
        bytes[i] = binaryStr.charCodeAt(i);
      }
      
      // Decompress using pako (zlib)
      const decompressed = pako.inflate(bytes, { to: 'string' });
      
      // Parse JSON
      return JSON.parse(decompressed);
    }
    
    // Handle if it's already a Uint8Array
    if (data instanceof Uint8Array) {
      const decompressed = pako.inflate(data, { to: 'string' });
      return JSON.parse(decompressed);
    }
    
    // Handle base64 encoded data
    if (typeof data === 'string' && data.length > 0) {
      try {
        // Try to decode from base64
        const binaryString = atob(data);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const decompressed = pako.inflate(bytes, { to: 'string' });
        return JSON.parse(decompressed);
      } catch (e) {
        // If not base64, might be encrypted
        console.log('Data might be encrypted:', e);
        return null;
      }
    }
    
    // If it's already an array, return as is
    if (Array.isArray(data)) {
      return data;
    }
    
    return null;
  } catch (error) {
    console.error('Error decompressing transcript:', error);
    return null;
  }
}